import Icon from '../components/Icon.vue'

Icon.register({
  bars: {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M16 132c-8.8 0-16-7.2-16-16v-40c0-8.8 7.2-16 16-16h416c8.8 0 16 7.2 16 16v40c0 8.8-7.2 16-16 16h-416zM16 292c-8.8 0-16-7.2-16-16v-40c0-8.8 7.2-16 16-16h416c8.8 0 16 7.2 16 16v40c0 8.8-7.2 16-16 16h-416zM16 452c-8.8 0-16-7.2-16-16v-40c0-8.8 7.2-16 16-16h416c8.8 0 16 7.2 16 16v40c0 8.8-7.2 16-16 16h-416z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/bars.js
// module id = 645
// module chunks = 0